// extracted by mini-css-extract-plugin
export default {"wrap":"MyReviews_wrap__aHRBz","subWrap":"MyReviews_subWrap__EKm3e","header":"MyReviews_header__jOk8f","menu":"MyReviews_menu__XgBsa","hr":"MyReviews_hr__aYq-v"};